module.exports = __webpack_public_path__ + "media/images/menu/csm_spain-1f9cbca5a87d986858031837aece95f3.png";